/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/kimiori/index.ts":
/*!******************************!*\
  !*** ./src/kimiori/index.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("__webpack_require__.r(__webpack_exports__);\n/**\n * 君オリについて\n */\nwindow.addEventListener(\"DOMContentLoaded\", function () {\n    /**\n     * 個性豊かな君オリメンバー\n     */\n    // .kimiori__sec3__members__item__quote の高さを揃える\n    {\n        // alignAllHeightsToMaximumHeight(\".kimiori__sec3__members__item__quote\", 10);\n        // alignAllHeightsToMaximumHeight(\".kimiori__sec3__members__item__description\", 10);\n        // window.addEventListener(\"resize\", () => {\n        // window.location.reload();\n        // });\n    }\n});\n\n\n\n//# sourceURL=webpack://coding/./src/kimiori/index.ts?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = {};
/******/ 	__webpack_modules__["./src/kimiori/index.ts"](0, __webpack_exports__, __webpack_require__);
/******/ 	
/******/ })()
;